import { BlobServiceClient } from '@azure/storage-blob'
import { AppConfigurationKey } from '../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../redux'
import AxiosInstance from '../../http-config'

export const getBlobServiceClient = async (
  container: string,
  path?: string,
  accountName?: AppConfigurationKey
): Promise<BlobServiceClient | null> => {
  var accountNameConf = accountName ?? AppConfigurationKey.StorageAccountName
  const storageAccountName = getAppConfigurationValue(accountNameConf)
  return await AxiosInstance.post(
    `${getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)}/GetSasToken`,
    {
      AccountName: storageAccountName,
      container,
      path
    }
  )
    .then(response => {
      const sasToken = response.data.sasToken

      const blobServiceClient = new BlobServiceClient(
        `https://${storageAccountName}.blob.core.windows.net${sasToken}`
      )

      return blobServiceClient
    })
    .catch(error => {
      console.log(error)
      return null
    })
}
